import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { CreateDepartmentData } from "../../services/DepartmentService";
import { toast } from "react-toastify";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";
function CreateDepartment({ ...props }) {
  const { t } = useTranslation();
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState([
    { label: t(`Department.Active`), value: "1", id: "1" },
    { label: t(`Department.Inactive`), value: "0", id: "0" },
  ]);

  /* State Field selected value */
  const handleStatusOptionSelection = id => {
    let record = status?.filter(item => item?.id == id);
    // console.log("Record:::", record);
    return record;
  };
  const handleChangeStatusValuePopulate = e => {
    //console.log('handleStatusValuePopulate:::',e)
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };

  /* Handle Change Event */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });
  };

  /* Handle Submit*/
  const handleSubmit = async content => {
    const formDataObject = new FormData();

    formDataObject.append("department_name", content.department_name);
    formDataObject.append("description", content.description);
    formDataObject.append("sequence", content.sequence);
    formDataObject.append("status", content.status);

    const fromEntriesObj = Object.fromEntries(formDataObject);

    let reqBody = fromEntriesObj;
    reqBody = encryptDataToArray(reqBody);

    CreateDepartmentData({
      query: reqBody,
    })
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (res?.status === 200) {
          let messages = toast.success(responseData?.message);

          setTimeout(() => {
            props?.history?.push("/department-list");
          }, 1000);
        } else {
          let messages = toast.error(responseData?.message);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  // Component Call
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  if (!checkPermissionStatus("department-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Department.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {/* <MetaTags><title>Create Department</title></MetaTags> */}

        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/department-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Department.Create Department`)}
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
              <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/department-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-4">
            <Container fluid>
              {/* <Breadcrumbs title="Department" breadcrumbItem="Create Department" /> */}

              <Col lg="12">
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => {
                    handleSubmit(formDataValues);
                  }}
                >
                  <div data-repeater-list="outer-group" className="outer">
                    <div data-repeater-item className="outer">
                      {successMessage && (
                        <div class="alert alert-success" role="alert">
                          {successMessage}
                        </div>
                      )}
                      {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}

                      <Row>
                        {/* <FormGroup className="mb-4" row>
                                                    <Col lg="3">
                                                    <Label htmlFor="banner_type" className="col-form-label">
                                                        Referral Employee Name:
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    </Col>
                                                    <Col lg="9">
                                                        <Select
                                                            id="faqsCategoryId"
                                                            placeholder="Select Category"
                                                            name="faqsCategoryId"
                                                            className="mb-3"        
                                                        />
                                                    <div className="error">{errors.faqsCategoryId}</div> 
                                                    </Col>
                                                </FormGroup>  */}
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="department_name"
                              className="col-form-label"
                            >
                              {t(`Department.Department Name`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="department_name"
                              name="department_name"
                              placeholder={t(`Department.Department Name`)}
                              errorMessage="Department Name Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(`Department.Name required`),
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage: t(
                                    `Department.Name min 2 characters`
                                  ),
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage: t(
                                    `Department.Name not more than 50 characters`
                                  ),
                                },
                                // Add more validation rules as needed
                                pattern: {
                                  value: /^[A-Za-z\s]+$/, // Regular expression for alphabetic characters and spaces
                                  errorMessage: t(
                                    `Department.Enter a valid name`
                                  ),
                                },
                              }}
                              value={formDataValues?.department_name || ""}
                              onChange={handleChange}
                              title={`Please enter ${t(
                                `Department.Department Name`
                              )}`}
                            />
                            <div className="error">
                              {errors.department_name}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="description"
                              className="col-form-label"
                            >
                              {t(`Department.Department Description`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="description"
                              name="description"
                              placeholder={t(
                                `Department.Department Description`
                              )}
                              errorMessage="Department Description Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    `Department.Department required`
                                  ),
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage: t(
                                    `Department.Department min 2 characters`
                                  ),
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage: t(
                                    `Department cannot exceed 50 characters`
                                  ),
                                },
                                // Add more validation rules as needed
                                // pattern: {
                                //     value: /^[A-Za-z\s]+$/,  // Regular expression for alphabetic characters and spaces
                                //     errorMessage: 'Please enter a valid Department with only alphabetic characters and spaces.',
                                //   },
                              }}
                              value={formDataValues?.description || ""}
                              onChange={handleChange}
                              title={`Please enter ${t(
                                `Department.Department Description`
                              )}`}
                            />
                            {/* <textarea className="form-control" id="description" name="postContent" rows={4} cols={40} /> */}

                            <div className="error">{errors.description}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="sequence"
                              className="col-form-label"
                            >
                              {t(`Department.Sequence`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="number"
                              className="form-control"
                              id="sequence"
                              name="sequence"
                              placeholder={t(`Department.Sequence`)}
                              errorMessage={t(
                                `Department.Department Sequence Required`
                              )}
                              validate={{ required: { value: true } }}
                              value={formDataValues?.sequence || ""}
                              onChange={handleChange}
                              title={`Please enter ${t(`Department.Sequence`)}`}
                            />
                            <div className="error">{errors.sequence}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label className="col-form-label">
                              {t(`Department.Status`)}{" "}
                            </Label>
                            <div
                              title={
                                formDataValues?.status
                                  ? status.find(
                                      option =>
                                        option.value === formDataValues.status
                                    )?.label
                                  : `Please enter ${t(`Department.Status`)}`
                              }
                            >
                              <Select
                                className="mb-3"
                                placeholder={t(`Department.Select Status`)}
                                id="status_id"
                                name="status"
                                validate={{ required: { value: true } }}
                                options={status}
                                value={handleStatusOptionSelection(
                                  formDataValues?.status
                                )}
                                onChange={e =>
                                  handleChangeStatusValuePopulate(e)
                                }
                                // menuIsOpen={true}
                              />
                            </div>
                            <div className="error">{errors.status}</div>
                          </FormGroup>
                        </Col>

                        <div className="cta text-center gap-3 d-flex justify-content-start mt-4 mb-4">
                          <Button
                            type="button"
                            className="btn btn-secondary"
                            onClick={e => {
                              props?.history?.push("/department-list");
                            }}
                          >
                            {t(`Department.Cancel`)}
                          </Button>
                          <Button
                            type="submit"
                            className="btn btn-primary"
                            color="success"
                          >
                            {t(`Department.Submit`)}
                          </Button>
                        </div>
                      </Row>
                    </div>
                  </div>
                </AvForm>
              </Col>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CreateDepartment;
